<template>
  <el-form-item 
    v-if="visible"
    :label="$t('lang.发热方式') + '：'">
    <el-select
      v-model="localValue"
      default-first-option
      :disabled="disabled"
      :placeholder="$t('lang.请选择')">
      <el-option 
        v-for="(item, index) in hotWindList" 
        :key="index" 
        :value="item.value" 
        :label="$t(`lang.${item.name}`)" />
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'OvenHeatType',
  props: {
    // v-model 绑定的值
    value: {
      type: [String, Number],
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    },
    hotWindList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('HEAT_MODE');
    },
    disabled() {
      return false;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    // 当选项列表改变时，如果当前值不在新列表中，清空
    hotWindList: {
      handler(newList) {
        if (this.value && !newList.find(item => String(item.value) === String(this.value))) {
          this.$emit('input', null);
        }
      },
      immediate: false
    }
  }
};
</script>

